/**
 * 写入答案
 */
import _this from '@/main.js'
export const SetAnswer = (result, list, refs) => {
    let resultArr = [];
    if (result) {
        resultArr = JSON.parse(result);
    }
    let quesTypeArr = ['35', '8', '10', '9', '6', '14', '37'];
    let matrixQuesTypeArr = ['19', '20', '21', '22', '39'];
    list.forEach((info, index) => {
        info.questionsName = setAppointQues(info.questionsName);
        info = setImgWidth(info)
        _this.$set(info, 'validate', false);
        switch (info.questionsTypeId) {
            case '11': // 星级打分
                _this.$set(info, 'userAnswer', -1);
                _this.$set(info, 'validateMsg', _this.$t('UserAnswer.RateTheOptions'));
                break;
            case '38': // 量表
                _this.$set(info, 'userAnswer', -10);
                _this.$set(info, 'validateMsg', _this.$t('UserAnswer.RateTheOptions'));
                break;
            case '10': // 多选
                _this.$set(info, 'userAnswerArr', []);
                _this.$set(info, 'validateMsg', _this.$t('UserAnswer.SelectOptions'));
                if (info.associated) {
                    // primary
                    info.primaryOptionList = [...info.optionList];
                }
                break;
            case '13': // 日期选择
                _this.$set(info, 'userAnswer', '');
                _this.$set(info, 'validateMsg', _this.$t('UserAnswer.SelectDate'));
                break;
            case '14': // 排序
                _this.$set(info, 'userAnswerArr', []);
                _this.$set(info, 'validateMsg', _this.$t('UserAnswer.SortAllOptions'));
                break;

            case '15': // 位置选择
                _this.$set(info, 'userAnswer', '');
                _this.$set(info, 'validateMsg', _this.$t('UserAnswer.SelectedPosition'));
                break;
            case '16': // 城市选择
                _this.$set(info, 'userAnswerArr', []);
                _this.$set(info, 'validateMsg', _this.$t('UserAnswer.EnsureCompleteAnswers'));
                break;
            case '17': // 时间选择
                _this.$set(info, 'userAnswer', '');
                _this.$set(info, 'validateMsg', _this.$t('UserAnswer.Timing'));
                break;
            case '8':
                _this.$set(info, 'userAnswer', '');
                _this.$set(info, 'validateMsg', _this.$t('UserAnswer.ChooseAnOption'));
                if (info.associated) {
                    // primary
                    info.primaryOptionList = [...info.optionList];
                }
                break;
            case '6':
            case '12':
            case '9':
                if (info.cutType && info.cutType == 8) {
                    _this.$set(info, 'userAnswerArr', []);
                    _this.$set(info, 'validateMsg', _this.$t('UserAnswer.SelectOptions'));
                } else {
                    _this.$set(info, 'userAnswer', '');
                    _this.$set(info, 'validateMsg', _this.$t('UserAnswer.ChooseAnOption'));
                }
                break;
            case '19':
            case '20':
            case '21':
            case '22':
            case '39':
                _this.$set(info, 'userAnswerArr', []);
                _this.$set(info, 'validateMsg', _this.$t('UserAnswer.CheckTheAnswers'));
                info.questionsSonList.forEach((el, i) => {
                    el.optionList.forEach((item, i) => {
                        if (!item.userAnswer) {
                            _this.$set(item, 'userAnswer', '');
                        }
                        if (info.questionsTypeId == '20') {
                            _this.$set(item, 'isSelected', false);
                        }
                        _this.$set(item, 'validate', false);
                        _this.$set(item, 'validateMsg', _this.$t('UserAnswer.InputContent'));
                    });
                });
                _this.$set(info, 'questionsSonListCopy', JSON.parse(JSON.stringify(info.questionsSonList)));
                break;
            case '35': // 多项填空
            case '34': // 横向填空
                _this.$set(info, 'userAnswer', 0);
                if (info.optionList.length > 0) {
                    info.optionList.forEach((item, i) => {
                        if (info.questionsTypeId == '34') {
                            _this.$set(item, 'userAnswer', '');
                        }
                        _this.$set(item, 'validate', false);
                        _this.$set(item, 'validateMsg', _this.$t('UserAnswer.InputContent'));
                    });
                }
                break;
            case '33': // 上传图片
                _this.$set(info, 'fileList', []);
                _this.$set(info, 'userAnswerArr', []);
                _this.$set(info, 'validate', false);
                _this.$set(info, 'validateMsg', _this.$t('UserAnswer.UploadFiles'));
                break;
            case '37': // 比重题
                _this.$set(info, 'validate', false);
                _this.$set(info, 'validateMsg', _this.$t('UserAnswer.SelectSpecificGravity'));
                break;

            default:
                _this.$set(info, 'userAnswer', '');
                _this.$set(info, 'validate', false);
                _this.$set(info, 'validateMsg', _this.$t('UserAnswer.InputContent'));
        }
        // 选项是否随机
        if (quesTypeArr.indexOf(info.questionsTypeId) !== -1 && info.optionIfRandom == 1) {
            if (info.ifFixedLastOption == 1) {
                // 固定最后一个选项
                info.optionList = optionRandom(info.optionList, 1);
            } else {
                info.optionList = optionRandom(info.optionList);
            }
        }
        // 行 列是否随机
        if (matrixQuesTypeArr.indexOf(info.questionsTypeId) !== -1) {
            if (info.matrixRankRandom == true) {
                info.questionsSonList = rowRandom(info.questionsSonList);
            }

            if (info.matrixLineRandom == true) {
                info.questionsSonList.forEach(val => {
                    // console.log(info)
                    val.optionList.forEach((el, index) => {
                        el.index = index;
                    });
                });
                info.questionsSonList[0].optionList = lineRandom(info.questionsSonList[0].optionList);
                // console.log(info.questionsSonList[0].optionList);
                let ruleArr = [];
                info.questionsSonList[0].optionList.forEach(val => {
                    ruleArr.push(val.index);
                });
                // console.log(ruleArr);
                info.questionsSonList.forEach(val => {
                    val.optionList.sort((a, b) => {
                        return ruleArr.indexOf(a.index) - ruleArr.indexOf(b.index);
                    });
                });
                // console.log(info.questionsSonList);
            }
        }

        resultArr.forEach(val => {
            if (val.qid == info.qid) {
                setQuesAnswer(val, info);
            }
        });
        if (result) {
            _this.$nextTick(() => {
                // console.log('this.$refs.AppearancePC :>> ', refs.AppearancePC);
                refs.AppearancePC.userAnswerChange(info);
                refs.AppearancePC.page = 0;
            });
        }
        
        info.questionsName = setSampleParam(info.questionsName)
    });
}


const setAppointQues = (name) => {
    let Reg = /(\[)Q[1-9]\d*(\])/g;
    let Arr = name.match(Reg);
    // console.log(Arr)
    if (Arr) {
        Arr.forEach(info => {
            let num = info.replace(/[^0-9]/gi, '');
            let html = `<span class="ques${num}"></span>`;
            name = name.replace(info, html);
            // console.log(name)
        });
    }
    return name;
}
		
// 处理图片
const setImgWidth = (info) => {
    info.questionsName = imgTagAddStyle(info.questionsName)
    if (info.optionList){
        info.optionList = info.optionList.map(option => {
            option.labelName = imgTagAddStyle(option.labelName)
            return option
        })
    }
    if (info.questionsSonList) {
        info.questionsSonList = info.questionsSonList.map(Son => {
            Son.questionsName = imgTagAddStyle(Son.questionsName)
            
            Son.optionList = Son.optionList.map(option => {
                // console.log(option)
                option.labelName = imgTagAddStyle(option.labelName)
                // console.log(option)
                return option
            })
            return Son
        })
    }
    return info
}
// 选项随机
const optionRandom = (array, state) => {
    // console.log(array);
    let res = [],
        random,
        quesArr = [],
        lastOptionArr = [];
    if (state == 1) {
        array.forEach((info, index) => {
            if (index == array.length - 1) {
                lastOptionArr.push(info);
            } else {
                quesArr.push(info);
            }
        });
    } else {
        quesArr = array;
    }
    while (quesArr.length > 0) {
        random = Math.floor(Math.random() * quesArr.length);
        res.push(quesArr[random]);
        quesArr.splice(random, 1);
    }
    return [...res, ...lastOptionArr];
}
		
// 行随机排列
const rowRandom = (array) => {
    let res = [],
        random;
    while (array.length > 0) {
        random = Math.floor(Math.random() * array.length);
        res.push(array[random]);
        array.splice(random, 1);
    }
    return res;
}
// 列随机排列
const lineRandom = (array) => {
    let res = [],
        random;
    while (array.length > 0) {
        random = Math.floor(Math.random() * array.length);
        res.push(array[random]);
        array.splice(random, 1);
    }
    return res;
}
		
// 答案回显
const setQuesAnswer = (val, info) => {
    if (info.questionsTypeId == 35 || info.questionsTypeId == 34 || info.questionsTypeId == 37) {
        info.optionList.forEach(option1 => {
            val.optionValue.forEach(option2 => {
                if (option1.oid == option2.oid) {
                    option1.userAnswer = option2.value;
                }
            });
        });
    } else if (info.questionsTypeId == 8) {
        info.userAnswer = val.value.split(':')[0];
        if (val.value.split(':')[1]) {
            info.optionList.forEach(option1 => {
                if (option1.oid == val.value.split(':')[0]) {
                    option1.inputValue = val.value.split(':')[1];
                }
            });
        }
    } else if (info.questionsTypeId == 10) {
        console.log(val)
        let arr = [];
        arr = val.value.split(',');
        arr.forEach(el => {
            info.userAnswerArr.push(el.split(':')[0]);
            info.optionList.forEach(option1 => {
                if (option1.oid == el.split(':')[0]) {
                    option1.inputValue = el.split(':')[1];
                }
            });
        });
    }else if (info.questionsTypeId == 14){
        val.value.forEach(el => {
            info.userAnswerArr.push(el.split(':')[0]);
            info.optionList.forEach(option1 => {
                if (option1.oid == el.split(':')[0]) {
                    option1.inputValue = el.split(':')[1];
                }
            });
        });
    } else if (info.questionsTypeId == 6 && info.cutType == 8) {
        // console.log(val)
        let arr = [];
        arr = val.value.split(',');
        arr.forEach(el => {
            info.userAnswerArr.push(el.split(':')[0]);
        });
    } else if (info.questionsTypeId == 16) {
        info.userAnswerArr = val.value;
    } else if (info.questionsTypeId == 19) {
        info.questionsSonList.forEach(son => {
            val.SonValue.forEach(SonValue => {
                if (son.SonId == SonValue.SonId) {
                    info.userAnswerArr.push({
                        SonId: son.SonId,
                        value: SonValue.value
                    });
                    son.isSelected = SonValue.value.split(':')[0];
                    son.inputValue = SonValue.value.split(':')[1] || '';
                    son.optionList.forEach(oid => {
                        if (SonValue.value.indexOf(oid.oid) !== -1) {
                            oid.inputValue = SonValue.value.split(':')[1] || '';
                        }
                    });
                }
            });
        });
    } else if (info.questionsTypeId == 20) {
        // console.log(val);
        info.questionsSonList.forEach(son => {
            val.SonValue.forEach(SonValue => {
                if (son.SonId == SonValue.SonId) {
                    info.userAnswerArr.push({
                        SonId: son.SonId,
                        value: SonValue.value
                    });
                    son.optionList.forEach(oid => {
                        let arr = [];
                        arr = SonValue.value.split(',');
                        arr.forEach(el => {
                            if (el.indexOf(oid.oid) !== -1) {
                                oid.isSelected = true;
                                oid.inputValue = el.split(':')[1] || '';
                            }
                        });
                    });
                }
            });
        });
    } else if (info.questionsTypeId == 21) {
        info.questionsSonList.forEach(son => {
            val.SonValue.forEach(SonValue => {
                if (son.SonId == SonValue.SonId) {
                    son.optionList.forEach(oid => {
                        SonValue.optionValue.forEach(el => {
                            if (oid.oid == el.oid) {
                                oid.ratingScore = el.value;
                            }
                        });
                    });
                }
            });
        });
    } else if (info.questionsTypeId == 22) {
        info.questionsSonList.forEach(son => {
            val.SonValue.forEach(SonValue => {
                if (son.SonId == SonValue.SonId) {
                    son.optionList.forEach(oid => {
                        SonValue.optionValue.forEach(el => {
                            if (oid.oid == el.oid) {
                                oid.userAnswer = el.value;
                            }
                        });
                    });
                }
            });
        });
    } else if (info.questionsTypeId == 33) {
        _this.$set(info, 'resultAnswerArrval', val.value.split(','))
    } else if (info.questionsTypeId == 36) {
        info.optionValue = val.value;
    } else {
        info.userAnswer = val.value;
    }
}
		
// 替换题目中的样本信息
const setSampleParam = (name) => {
    const reg = /(@@Sample\[).*?(\]@@)/g
    let arr = name.match(reg)
    if (arr) {
        arr.forEach((info) => {
            console.log(info)
            sampleParamList.forEach(val => {
                if (name.indexOf(info) !== -1 && info.indexOf(val.chfieldName) !== -1) {
                    name = name.replace(info, val.value)
                }
            })
        })
    }
    return name
}
		
const imgTagAddStyle = (htmlstr) =>{
    //正则匹配所有img标签
    var regex0 = new RegExp("(i?)(\<img)([^\>]+\>)","gmi");
    // console.warn(regex0.test(htmlstr))
    if (regex0.test(htmlstr)) {
        //正则匹配不含style="" 或 style='' 的img标签
        var regex1 = new RegExp("(i?)(\<img)(?!(.*?style=['\"](.*)['\"])[^\>]+\>)","gmi");
        //给不含style="" 或 style='' 的img标签加上style=""
        htmlstr = htmlstr.replace(regex1, "$2 style=\"\"$3");
        // console.log("增加style=\"\"后的html字符串："+htmlstr);
        //正则匹配含有style的img标签
        var regex2 = new RegExp("(i?)(\<img.*?style=['\"])([^\>]+\>)","gmi");
        //在img标签的style里面增加css样式(这里增加的样式：display:block;max-width:100%;height:auto;border:5px solid red;)
        htmlstr = htmlstr.replace(regex2, "$2max-width:100%;height:auto;$3");
        // console.log("在img标签的style里面增加样式后的html字符串："+htmlstr);
    }
    return htmlstr;
}